import { useMutation, useQuery } from '@tanstack/react-query';
import {
  getConsultMoreDetails,
  getSessionDocument,
  pastSession,
  sessionDownloadDocument,
} from '../services/consultMoreDetailsServices';
import type {
  DocumentId,
  SessionDetails,
} from '../services/consultMoreDetailsServices';
import { REFRESH_INTERVAL } from '@qler-view/shared_lib/src/shared/constants/CommanConstants';

export const useConsultMoreDetails = (consultId: number, userId: number) => {
  const { data, isLoading, isError, error, refetch } = useQuery<SessionDetails>(
    {
      queryKey: ['consultMoreDetails', consultId],
      queryFn: async () => {
        const data = await getConsultMoreDetails(consultId, userId);
        return data;
      },
      staleTime: 0,
      gcTime: 0,
      refetchInterval: REFRESH_INTERVAL,
      enabled: !!consultId,
    }
  );

  return {
    consultMoreDetails: data,
    isLoading,
    isError,
    error,
    refetch,
  };
};

export const usePastSession = (consultId: number) => {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['PastSessionList', consultId],
    queryFn: async () => {
      const data = await pastSession(consultId);
      return data;
    },
    refetchInterval: REFRESH_INTERVAL,
  });
  return {
    PastSessionList: data,
    isLoading,
    isError,
    error,
    refetch,
  };
};

export const useGetSessionDocuments = (userId: number, consultId: number) => {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['SessionDocumentList', userId, consultId],
    queryFn: async () => {
      const data = await getSessionDocument(consultId);
      return data;
    },
  });
  return {
    SessionDocumentList: data,
    isLoading,
    isError,
    error,
    refetch,
  };
};

export const useDownloadDocument = () => {
  return useMutation<string, Error, DocumentId>({
    mutationFn: async (docID) => {
      const data = await sessionDownloadDocument(docID.documentId);
      return data;
    },
  });
};
